module.exports = __webpack_public_path__ + "static/media/3.3c09b9b8.jpg";